export enum Permission {
  ConnectedStoresView = 'connected_stores.view',
  CaperModify = 'caper.modify',
  UposViewStatus = 'upos.view_status',
  UposConfigRetailer = 'upos.config_retailer',
  UposConfigStore = 'upos.config_store',
  ShelfLabelsModify = 'shelf_labels.modify',
  CaperTransactionsView = 'caper_transactions.view',
}
